import "../../assets/css/modal.css";
import { IoMdClose } from "react-icons/io";
import testIcon from "../../assets/images/icon/heart.png";
import ApiSelectBar from "../button/ApiSelectBar";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import ApiListButton from "../button/ApiModalListButton";
import { useRecoilValue } from "recoil";
import { apiProductsState } from "../../atom/Products";
import { useEffect, useState } from "react";
import { apiKeyState } from "../../atom/ApiKey";

export default function TestApiModal({ isOpen, onClose, children }) {
  if (!isOpen) return null;
  const apiProducts = useRecoilValue(apiProductsState);
  const apiKeys = useRecoilValue(apiKeyState);
  const [isValue, setValue] = useState("1");

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="cusom-modal-header">
          <div
            style={{
              fontWeight: `800`,
            }}
          >
            API 관리
          </div>
          <div
            className="close-button"
            onClick={onClose}
            style={{ cursor: `pointer` }}
          >
            <IoMdClose size={30} />
          </div>
        </div>
        <div
          style={{
            display: `flex`,
            width: `100%`,
            flex: 1,
          }}
        >
          <div className="custom-box-left">
            <div className="custom-sub-title">
              {isValue === "1" ? <>신청 가능한 API</> : <>사용중인 API</>}
            </div>
            <div className="custom-in-right-box">
              {isValue === "1" &&
                apiProducts.map((item, index) => (
                  <ApiSelectBar key={index} data={item} />
                ))}

              {isValue === "2" &&
                apiKeys.map((item, index) => (
                  <ApiSelectBar key={index} data={item} />
                ))}
            </div>
          </div>
          <div className="custom-box-right">
            <div className="test">
              <div
                style={{ backgroundColor: `#F5F5F5`, width: `100%`, flex: 5 }}
              >
                <div className="apiListBackgroundBox">
                  <ApiListButton
                    text="신청가능한 API"
                    value="1"
                    isActive={isValue === "1"}
                    onClick={() => setValue("1")}
                  />
                  <div style={{ height: `20px` }}></div>
                  <ApiListButton
                    text="사용중인 API"
                    value="2"
                    isActive={isValue === "2"}
                    onClick={() => setValue("2")}
                  />
                </div>
              </div>
              <div style={{ backgroundColor: `white`, width: `100%`, flex: 4 }}>
                <div style={{ margin: `20px` }}>
                  <div className="custom-sub-title">테스트 API 안내</div>
                  {isValue === "1" ? (
  <div>
  테스트 API를 선택하여 신청하세요. 발급된 API 키는 [사용중인 API] 탭에서 확인할 수 있습니다.
   </div>
                  ) : (
                    <div>
                    사용중인 API를 선택하시면 해당 API Key가 클립보드로 복사됩니다. API추가는 [신청가능한 API]에서 확인할 수 있습니다.
                     </div>
                  )}
                
                
                </div>
              </div>
              <div
                style={{
                  backgroundColor: `#F5F5F5`,
                  width: `100%`,
                  flex: 1,
                  display: `flex`,
                  justifyContent: `space-between`,
                  alignItems: `center`,
                  padding: `10px`,
                  borderBottomRightRadius: `32px`,
                }}
              >
                {/* <button
                  style={{
                    backgroundColor: `red`,
                    padding: `15px`,
                    width: `100%`,
                    color: `white`,
                    fontWeight: `800`,
                    fontSize: `16px`,
                    borderRadius: `8px`,
                    borderRadius: `8px`,
                  }}
                  onclick
                >
                  취소
                </button> */}
                {/* <div style={{ width: `30px` }}></div> */}

                <button
                  style={{
                    backgroundColor: `#1977F3`,
                    padding: `15px`,
                    width: `100%`,
                    color: `white`,
                    fontWeight: `800`,
                    fontSize: `16px`,
                    borderRadius: `8px`,
                  }}
                  onClick={onClose}
                >
                  확인
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
